module.exports = __webpack_public_path__ + "static/media/cover-silica-as-a-risk.37f05668.jpg";